import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import Divider from '@material-ui/core/Divider'
import { makeStyles, Theme } from '@material-ui/core/styles'
import clsx from 'clsx'
import React from 'react'

const tabResultAreaStyles = makeStyles((theme: Theme) => ({
    tabContent: {
        fontSize: pxToRem(12),
        paddingTop: theme.spacing(2),
        paddingLeft: theme.spacing(0.5),
        paddingRight: theme.spacing(0.5),
    },
    tabResultArea: {
        height: 450,
        overflowY: 'auto',
        overflowX: 'hidden',
        marginTop: theme.spacing(2),
    },
    blackDivider: {
        backgroundColor: '#000000!important',
    },
}))

export interface TabResultAreaProps {
    hidden?: boolean
    title: string
}

const TabResultArea: React.FC<TabResultAreaProps> = ({
    hidden = false,
    title,
    children,
}) => {
    const classes = tabResultAreaStyles()

    return (
        <div
            hidden={hidden}
            className={clsx(classes.tabContent, 'tabResultArea')}
        >
            <span className="tabResultTitle">{title}</span>
            <Divider
                classes={{
                    root: classes.blackDivider,
                }}
            />
            <GridContainer className={classes.tabResultArea}>
                <GridItem xs={12} sm={12} md={12}>
                    {children}
                </GridItem>
            </GridContainer>
        </div>
    )
}

export default TabResultArea
